import { ref } from 'vue'

/**
 * Global state for 2FA enforcement.
 * When the backend returns a 403 with error "two_factor_required",
 * we show a modal dialog guiding the user to set up 2FA.
 */
const showEnforcementDialog = ref(false)
const enforcementMessage = ref('')

export function useTwoFactorEnforcement() {
  /**
   * Trigger the 2FA enforcement dialog.
   * Called by the API interceptor when a 403 two_factor_required response is received.
   */
  function triggerEnforcement(message?: string) {
    enforcementMessage.value = message || 'Your organization requires two-factor authentication to continue.'
    showEnforcementDialog.value = true
  }

  /**
   * Dismiss the enforcement dialog.
   */
  function dismissEnforcement() {
    showEnforcementDialog.value = false
    enforcementMessage.value = ''
  }

  return {
    showEnforcementDialog,
    enforcementMessage,
    triggerEnforcement,
    dismissEnforcement
  }
}
